export class DefaultMessage {
  isRelevant() {
    // eslint-disable-next-line no-console
    console.log('DEFAULT MESSAGE');
    return false;
  }
}
